// Form 用 JS
require('./form/leads');
require('./form/inputs');
require('./vendor/autokana');

// Form 用 CSS
import '../styles/form/main.scss';
